import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
const UsualySearched = () => {
  const { t } = useTranslation();

  const defaultPopular = [
    "hashtag1",
    "hashtag2",
    "hashtag3",
    "hashtag4",
    "hashtag5",
  ];

  const [customTags, setCustomTags] = useState([]);

  useEffect(() => {
    const storedTags = JSON.parse(localStorage.getItem("hashtags") || "[]");
    setCustomTags(storedTags);
  }, []);

  useEffect(() => {
    const searches = JSON.parse(localStorage.getItem("searches") || "{}");

    const newTags = Object.entries(searches)
      .filter(([_, count]) => count >= 3)
      .map(([key]) => key)
      .filter(
        (word) => !defaultPopular.includes(word) && !customTags.includes(word),
      );

    if (newTags.length === 0) return;

    const updated = [...customTags, ...newTags].slice(-10);

    localStorage.setItem("hashtags", JSON.stringify(updated));
    setCustomTags(updated);
  }, []); // ⬅️ ВАЖНО: только 1 раз

  const allTags = useMemo(
    () => [...defaultPopular, ...customTags],
    [customTags],
  );


console.log("ACTIVE LANG:", i18n.language);
console.log("TEST 1:", i18n.t("hashtag1"));

  return (
    <section className="w-[600px] max-md:w-full flex flex-col gap-3">
      <h1 className="text-white text-4xl max-sm:text-xl uppercase font-bold">
        {t("Popularsearches")}
      </h1>

      <ul className="flex flex-wrap gap-3">
        {allTags.map((word) => (
          <li key={word}>
            <Link
              className="p-2 block bg-gray-100 rounded-md max-sm:text-sm max-sm:p-1 hover:bg-[#006674] hover:text-white transition"
              to={`/search?q=${encodeURIComponent(t(word))}`}
            >
              #{t(word)}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default UsualySearched;
